import { useInView } from "react-intersection-observer";
import H3 from "../H3";
import P18 from "../P18";
import "./index.scss";
import classNames from "classnames";

const MissionList = ({ block }: { block: any }) => {
  const { ref, inView, entry } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  return (
    <div className={classNames("mission-list", inView && "animated")} ref={ref}>
      <H3 text={block?.listTitle} />
      <ul className="mission-list__list">
        {block?.list?.map((c: any, i: number) => (
          <li className="mission-list__item" key={i}>
            <P18 text={c} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MissionList;
